import { NavLink } from '@lmt/unicorn-shared/app/components/navigation/types';

import { useIsSuperUser } from '@lmt/unicorn-shared/app/components/users/superuser/utils/useIsSuperUser';
import { getTabs } from '@lmt/unicorn-shared/app/features/navigation/selectors';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import { useInvalidateQueries } from '@lmt/unicorn-shared/app/usePrefetchQueries';
import * as React from 'react';
import { Freeze } from 'react-freeze';
import { QueryMetaProvider } from 'react-query-swagger';
import { Outlet } from 'react-router';
import { UserList } from './components/users/list/UserList';
import { pages } from './constants/sharedRoutes';
import { lazyRetry } from './helpers/retry-helper';
import { useTabId } from './components/keep-alive/TabContext';

export const TabContents: React.FC = () => {
  const openedTabs: NavLink[] = useUniSelector(getTabs);
  const currentTabId = useTabId();
  const patientsTabRouteMatch = pages.patients.useMatch();
  const calendarTabRouteMatch = pages.calendar.useMatch();
  const dashboardTabRouteMatch = pages.dashboard.useMatch();
  const isSuperUser = useIsSuperUser();

  if (isSuperUser) {
    return <UserList />;
  }

  const isNotMatchingRoute =
    !patientsTabRouteMatch && !calendarTabRouteMatch && !currentTabId;
  const isDashboardShown = !!dashboardTabRouteMatch || isNotMatchingRoute;

  useInvalidateQueries();
  return (
    <>
      {openedTabs.map((tab) => {
        return (
          <Freeze freeze={tab.id !== currentTabId} key={tab.id}>
            <QueryMetaProvider meta={{ tabId: tab.id }}>
              <Outlet />
            </QueryMetaProvider>
          </Freeze>
        );
      })}

      <Freeze freeze={!patientsTabRouteMatch}>
        <QueryMetaProvider meta={{ tabId: 'patients' }}>
          <Outlet />
        </QueryMetaProvider>
      </Freeze>
      <Freeze freeze={!isDashboardShown}>
        <QueryMetaProvider meta={{ tabId: 'dashboard' }}>
          <Outlet />
        </QueryMetaProvider>
      </Freeze>
      <Freeze freeze={!calendarTabRouteMatch}>
        <QueryMetaProvider meta={{ tabId: 'calendar' }}>
          <Outlet />
        </QueryMetaProvider>
      </Freeze>
    </>
  );
};
